import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

// Role-related actions
export const getRoleByGroupLibAsync = createAsyncThunk(
  'role/fetch-roles-by-group',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v2/rbac-config/fetch-roles-by-group', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getRolesLibAsync = createAsyncThunk(
  'role/fetch-all-roles',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    let url = `v2/rbac-config/fetch-all-roles`
    return await AxiosClient('GET', url, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const deleteRoleLibAsync = createAsyncThunk(
  'role/remove-roles-from-group',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v2/rbac-config/remove-roles-from-group', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const createRoleLibAsync = createAsyncThunk(
  'role/create-role',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v2/rbac-config/create-role', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const assignRoleToGroupLibAsync = createAsyncThunk(
  'admin/assign-role-to-group',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v2/rbac-config/assign-role-to-group', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const updateRoleDescriptionLibAsync = createAsyncThunk(
  'role/update-role-description',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v2/rbac-config/update-role-description', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
